/* DN: Custom Element für PDP Quantity Tiers */
class DnQuantityTiers extends HTMLElement {
  connectedCallback() {
    this.tiles = this.querySelectorAll('.dn-qt__tile');
    this.tiles.forEach(t => t.addEventListener('click', e => this.select(e.currentTarget)));

    // Apply default-active tile's quantity on init
    const defaultTile = this.querySelector('.dn-qt__tile.is-active');
    if (defaultTile) this.applyQuantity(parseInt(defaultTile.dataset.quantity, 10));
  }

  select(tile) {
    const qty = parseInt(tile.dataset.quantity, 10);
    if (!qty) return;
    this.tiles.forEach(t => t.classList.toggle('is-active', t === tile));
    this.applyQuantity(qty);
  }

  applyQuantity(qty) {
    if (!qty) return;

    const productInfo = this.closest('product-info, product-form, main, .shopify-section');
    if (!productInfo) return;

    // 1. Try Stretch's quantity-selector custom element setter (if rendered)
    const selector = productInfo.querySelector('quantity-selector');
    if (selector && 'quantity' in selector) {
      selector.quantity = qty;
    }

    // 2. Find ALL quantity inputs (sometimes outside selector, in cart drawer, etc.)
    productInfo.querySelectorAll('input[name="quantity"]').forEach(inp => {
      inp.value = qty;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
      inp.dispatchEvent(new Event('input', { bubbles: true }));
    });

    // 3. Inject/update hidden quantity input in ALL cart-add forms.
    //    Stretch PDP has TWO forms: main product-form + payment-installment form.
    //    If we only hit the first, that's payment-installment — main form gets
    //    no quantity, Shopify defaults to 1 → wrong cart quantity. Hit them all.
    productInfo.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      let hidden = form.querySelector('input[name="quantity"][data-dn-qt]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'quantity';
        hidden.dataset.dnQt = 'true';
        form.appendChild(hidden);
      }
      hidden.value = qty;
    });
  }
}

if (!customElements.get('dn-quantity-tiers')) {
  customElements.define('dn-quantity-tiers', DnQuantityTiers);
}
